import { colors } from '../styles/vars';

const defaultStyleMap = {
  overflow: {
    color: colors['dusty-orange'],
  },
  SUBSCRIPT: {
    fontSize: '0.83em',
    verticalAlign: 'sub',
  },
  SUPERSCRIPT: {
    fontSize: '0.83em',
    verticalAlign: 'super',
  },
};

export function getStyleMap({ disabledInlineStyles = [] } = {}) {
  const styleMap = { ...defaultStyleMap };

  disabledInlineStyles.forEach((style) => {
    styleMap[style] = {};
  });

  return styleMap;
}

export default defaultStyleMap;
